module.exports = __webpack_public_path__ + "img/img_select_an.0078cf29.png";